module.exports = __webpack_public_path__ + "static/media/background3.d7f31a38.png";